<template>
  <div class="about">
      <div class="about-info">
        <p class="about-title">关于我们</p>
        <div class="about-label">关于蓝凌</div>
        <div class="about-label">联系我们</div>
        <div class="about-label">产品应用</div>
      </div>
       <div class="about-info">
        <p class="about-title">服务与帮助</p>
        <div class="about-label">新手指南</div>
        <div class="about-label">使用指南</div>
        <div class="about-label">常见问题</div>
      </div>
       <div class="about-info">
        <p class="about-title">常见问题</p>
        <div class="about-label tel">4008-345-678</div>
        <div class="about-label name">深圳市蓝凌软件股份有限公司</div>
        <div class="about-label address">深圳市南山区深南大道9966号威盛科技大厦10楼</div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  }
}
</script>
<style lang="less" scoped>
.about{
  // padding-left: 120px;
  // padding-top:120px;
  width:1200px;
  margin: 0 auto;
  background: url('../assets/map.png') top right no-repeat;
  background-size: 750px;
  height: 426px;;
  .about-info{
    display: inline-block;
    margin-right:140px;
  }
  .about-title{
    font-size: 16px;
    color: #333333;
    text-align: center;
    line-height: 18px;
    text-align: left;
    margin-bottom:40px;
  }
  .about-label{
    font-size: 16px;
    color: #999999;
    text-align: center;
    line-height: 16px;
    text-align: left;
    margin-bottom:20px;
  }
  .tel{
   font-size: 28px;
color: #4285F4;
line-height: 26px;
margin-bottom:9px;

  }
  .name{
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    margin-bottom:18px;
  }
  .address{
    font-size: 14px;
color: #999999;
line-height: 16px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/about.vue